import React from 'react';
import { Checkbox, Collapse, Calendar, Card, Button, Spin, Space } from 'antd';

import { PlusOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

import * as calendarConsts from '../../constants/calendar-constants';

import CalendarCheckbox from '../calendar-checkbox/calendar-checkbox';
import './calendar-sidebar.less';

const CalendarSidebar = ({
  rootContainer,
  loading,
  groupFilters,
  extendedCategories,

  onEditCategory,
  onDeleteCategory,
  onAddCategory,

  selectedCategories,
  selectedGroups,
  selectedDate,

  dateChangeCallback: dateChangeCallback,
  categoriesChangeCallback: categoriesChangeCallback,
  filtersChangeCallback: filtersChangeCallback,
}) => {
  const onChangeFilters = (checkedValues) => {
    if (typeof filtersChangeCallback === 'function') {
      filtersChangeCallback(checkedValues);
    }
  };

  const onChangeCategories = (checkedValues) => {
    if (typeof categoriesChangeCallback === 'function') {
      categoriesChangeCallback(checkedValues);
    }
  };

  const onDateChange = (momentObj) => {
    if (typeof dateChangeCallback === 'function') {
      dateChangeCallback(momentObj.clone().startOf('day'));
    }
  };

  return (
    <Spin spinning={loading} style={{ maxHeight: 'unset' }}>
      <Card size="small" className="calendar-sidebar">
        <Calendar fullscreen={false} value={selectedDate} onChange={(val) => onDateChange(val)} />

        <Collapse defaultActiveKey={['1', '2']}>
          <Panel header="Calendar Filters" key="1">
            <Checkbox.Group style={{ width: '100%' }} value={selectedGroups} onChange={onChangeFilters}>
              {groupFilters &&
                groupFilters.map((group, k) => (
                  <CalendarCheckbox
                    key={'filter-' + k}
                    item={group}
                    canChange={false}
                    rootContainer={rootContainer}
                    onEdit={onEditCategory}
                    onDelete={onDeleteCategory}
                  />
                ))}
            </Checkbox.Group>
          </Panel>

          {extendedCategories ? (
            <Panel
              header="Calendar Categories"
              key="2"
              extra={
                <Button
                  type="default"
                  size="small"
                  className="calendar-category-btn"
                  onClick={($event) => {
                    onAddCategory($event);
                    $event.preventDefault();
                    $event.stopPropagation();
                  }}
                  title="Add"
                >
                  Add
                </Button>
              }
            >
              <Checkbox.Group style={{ width: '100%' }} value={selectedCategories} onChange={onChangeCategories}>
                {extendedCategories.map((category, k) => (
                  <CalendarCheckbox
                    key={'category-' + k}
                    item={category}
                    canChange={category.id !== calendarConsts.GUID_EMPTY}
                    rootContainer={rootContainer}
                    onEdit={onEditCategory}
                    onDelete={onDeleteCategory}
                  />
                ))}
              </Checkbox.Group>
            </Panel>
          ) : null}
        </Collapse>
      </Card>
    </Spin>
  );
};

export default CalendarSidebar;
